import { useEffect, useState } from 'react';
import CircuitTable from 'components/circuit-table';
import imgUrl from '../images/genesis-panel.jpg';
import { msg } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';
import { Tooltip } from '@thermon-platforms/thermon-ui-core';
import { lockOut } from 'util/device';
import useDevicesStore from 'store/devices';

function PanelView({device}) {
  const { _ } = useLingui();
  const [, devicesStoreActions] = useDevicesStore();

  return (
    <>
    <header>
      <h2>
      <span className={`status-icon ${device.model.lockedOut ? 'locked-out' : 'ok'}`}></span>
        {device?.model?.name}
      </h2>
      <ul className="device-controls">
        <li>
          <button
            className="network"
            data-tooltip-content={_(msg`Network Settings`)}
            data-tooltip-id="control-tooltip"
          >
            <Trans>Network Settings</Trans>
          </button>
        </li>
        <li>
          <button
            className={`lock-out ${device.model.lockedOut ? 'active' : ''}`}
            data-tooltip-content={_(msg`Lock Out / Tag Out`)}
            data-tooltip-id="control-tooltip"
            onClick={() => lockOut(device, devicesStoreActions.forceUpdate)}
          >
            <Trans>Lock Out / Tag Out</Trans>
          </button>
        </li>
      </ul>
      <Tooltip id="control-tooltip" place="bottom-end" />
    </header>
    <section>
      <div className="overview">
        <ul>
          <li>
            <strong>Status</strong>: {device.model.lockedOut ? 'Locked Out' : 'OK'}
          </li>
          <li><strong>Type</strong>: Genesis Panel</li>
        </ul>
        <img src={imgUrl} />
      </div>
      <CircuitTable device={device} />
    </section>
    </>
  )
}

export default PanelView;
